<script>
import { Dropdown } from 'vue-bootstrap';

/**
 * The DashboardMenu component.
 */
export default {
  components: {
    Dropdown
  }
};
</script>
